// extracted by mini-css-extract-plugin
export default {"input":"sigin_in_page-module___input___c44cefc6","button":"sigin_in_page-module___button___d7955e68"};